// extracted by mini-css-extract-plugin
var _1 = "bnuiF";
var _2 = "dO5AA";
var _3 = "dbRkh";
export { _1 as "placeholder", _2 as "shrinkable", _3 as "underlay" }
